export default "__VITE_ASSET__BSZDvxj9__"